import { mapActions, mapGetters } from "vuex";
import { dynamicHead } from "../../../mixins/dynamic-head";

export default {
    name: "server-not-found",
    mixins: [dynamicHead],
    head: () => {
        return {
            title: () => {
                return {
                    inner: "Точка ",
                    separator: "|",
                    complement: "500 - Server Not Found",
                };
            },
            meta: () => {
                let meta = [
                    { n: "prerender-status-code", c: "500" },
                    { n: "robots", c: "noindex, nofollow" },
                ];
                return meta;
            },
        };
    },
    data() {
        return {};
    },
    components: {},
    computed: {
        ...mapGetters({}),
    },
    created() {},
    methods: {
        ...mapActions({}),
    },
};
